<template>
  <div
    class="apply-add-wrap"
    id="applyAdd"
  >
    <div class="title-wrap">
      <div>{{ this.applyUserId ? "编辑申请人" : "新增申请人" }}</div>
      <img
        src="@/assets/img/btn_close.png"
        class="close-img"
        @click.stop="handleCancel"
      >
    </div>
    <van-form
      ref="form"
      label-align="right"
      validate-first
      :show-error-message="false"
    >
      <div class="cell">
        <van-field
          v-model.trim="formData.name"
          required
          name="name"
          :maxlength="20"
          label="姓名"
          label-align="left"
          clearable
          placeholder="请填写姓名"
          label-width="1.62rem"
          class="custom-field-font"
        />

        <van-cell>
          <div class="info-item">
            <div class="label-wrap">
              <div class="label">性别</div>
              <div class="sex-tips">*</div>
            </div>
            <van-radio-group
              v-model="formData.sex"
              class="sex-content"
            >
              <van-radio
                name="M"
                checked-color="#FF6B22"
                icon-size="15px"
              >男</van-radio>
              <van-radio
                name="F"
                checked-color="#FF6B22"
                radio-size="30px"
                style="margin-left: 20px"
                icon-size="15px"
              >女</van-radio>
            </van-radio-group>
          </div>
        </van-cell>

        <van-field
          v-model.trim="formData.birthday"
          required
          type="data"
          is-link
          readonly
          name="birthday"
          label="出生年月日"
          label-align="left"
          placeholder="请选择出生年月日"
          @click="showDatePicker = true"
          label-width="1.62rem"
          class="custom-field-font"
        />

        <van-field
          v-model.trim="formData.mobilePhone"
          required
          name="mobilePhone"
          :maxlength="11"
          type="tel"
          label="联系电话"
          label-align="left"
          placeholder="请输入"
          clearable
          label-width="1.62rem"
          class="custom-field-font"
        />

        <van-field
          v-model.trim="formData.pin"
          center
          clearable
          required
          maxlength="6"
          type="digit"
          label-align="left"
          label="短信验证码"
          placeholder="请输入验证码"
          label-width="1.62rem"
          class="custom-field-font"
        >
          <template #button>
            <div class="send-pin-cell">
              <div class="line" />
              <span
                class="send-btn"
                @click.stop="sendpinClick"
              >
                <span
                  class="unsent"
                  :class="{ 'count-down': pinDisable }"
                >{{
                  pinTitle
                }}</span>
              </span>
            </div>
          </template>
        </van-field>
        <div class="tips">您的信息由“中保车服”收集，以便为您提供健康服务</div>
      </div>
    </van-form>

    <div class="bottom">
      <van-button
        class="btn-cancel"
        type="info"
        @click="handleCancel"
      >取消</van-button>
      <van-button
        class="btn"
        type="info"
        :disabled="submitLoading"
        @click="handleSubmit"
      >确认</van-button>
    </div>

    <!-- 日期选择器弹出层 -->
    <van-popup
      v-model.trim="showDatePicker"
      round
      position="bottom"
    >
      <van-datetime-picker
        type="date"
        :formatter="dateFormatter"
        :max-date="maxDate"
        :min-date="minDate"
        :value="defaultDate"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { throttle } from 'lodash';
import { complement0 } from '@/utils/index';
import { debounce } from 'lodash';
import { Toast } from 'vant';
import {
  channelUserCreateOphthalmic,
  paicApplyUserPhonePinGet,
  channelGetHOpenId,
  channelUserGet,
  channelUserUpdateOphthalmic
} from '@/common/api.js';
import { MobileRegExp } from '@/common/regex.js';

function initFormData() {
  return {
    name: '',
    mobilePhone: '',
    sex: '',
    birthday: '',
    pin: '',
    applyUserId: '',
    userId: ''
  };
}

export default {
  name: 'Applicat',
  data() {
    return {
      formData: {
        ...initFormData()
      },
      pinTitle: '发送验证码',
      pinDisable: false,
      showDatePicker: false,
      submitLoading: false,
      countDownSecond: 60,
      maxDate: new Date(),
      minDate: new Date('1924/1/1'),
      defaultDate: new Date(),
      channel: '',
      applyUserId: ''
    };
  },
  mounted() {
    this.getDefaultParameters();
  },
  updated() {
    this.postMessage();
  },
  methods: {
    postMessage() {
      // 获取窗口宽度
      const width = document.documentElement.clientWidth;
      // 获取窗口高度
      const element = document.getElementById('applyAdd');
      const height = element.scrollHeight;
      const data = { data: { width: width, height: height }};
      // 单独用window.postMessage 接收不到
      window.parent.postMessage(data, '*');
      console.log('发送宽高消息', data);
    },
    getDefaultParameters() {
      this.formData = {
        ...initFormData()
      };
      const defaultData = this.$route.query.data;
      console.log('接收的参数:', this.$route.query);
      if (defaultData) {
        const data = JSON.parse(defaultData);
        this.formData.name = data.name || '';
        this.formData.mobilePhone = data.mobilePhone || '';
        this.formData.sex = data.sex || '';
        this.formData.birthday = data.birthday || '';
        if (this.formData.birthday) {
          this.defaultDate = new Date(this.formData.birthday);
        }
      }
      this.channel = this.$route.query.channel || '';
      this.code = this.$route.query.code || '';
      this.applyUserId = this.$route.query.userId || ''; // 他们前端传过来的，对应我们的applyUserId
      this.formData.applyUserId = this.applyUserId;
      console.log(this.formData);
      this.getOpenId();
      if (this.applyUserId) {
        this.getUserInfo();
      }
    },
    handleCancel() {
      const data = { data: 'cancel' };
      window.parent.postMessage(data, '*');
      console.log('发送取消消息：', data);
    },
    handleSubmit: throttle(async function() {
      try {
        const valid = this.checkSubmit();
        if (!valid) {
          return;
        }
        this.submitLoading = true;
        this.$toast.loading({
          message: '提交中',
          forbidClick: true,
          duration: 0
        });
        const params = {
          ...this.formData
        };
        const url = this.formData.applyUserId
          ? channelUserUpdateOphthalmic
          : channelUserCreateOphthalmic;
        await url(params);
        this.submitLoading = false;
        this.$toast.clear();
        const data = { data: 'confirm', userId: this.formData.userId };
        Toast('保存成功');
        setTimeout(() => {
          // 给平安发送消息
          window.parent.postMessage(data, '*');
          console.log('发送成功消息：', data);
        }, 500);
      } catch (error) {
        this.submitLoading = false;
        if (error.length > 0) {
          const item = error[0];
          Toast(item.message);
        }
      }
    }, 2000),
    checkSubmit() {
      if (!this.formData.name) {
        Toast('姓名不能为空');
        return false;
      }
      const nameReg = /^[\u4e00-\u9fa5]{1,20}$/;
      if (!nameReg.test(this.formData.name)) {
        Toast('姓名仅支持中文');
        return false;
      }
      if (!this.formData.sex) {
        Toast('性别不能为空');
        return false;
      }
      if (!this.formData.birthday) {
        Toast('出生年月日不能为空');
        return false;
      }
      if (!this.formData.mobilePhone) {
        Toast('联系电话不能为空');
        return false;
      }
      if (!MobileRegExp.test(this.formData.mobilePhone)) {
        Toast('请输入正确的联系电话码');
        return false;
      }
      if (!this.formData.pin) {
        Toast('验证码不能为空');
        return false;
      }
      return true;
    },
    async getOpenId() {
      try {
        const params = {
          code: this.code,
          productCategoryCode: 'FLH0000005'
        };
        const res = await channelGetHOpenId(params);
        this.formData.userId = res;
        console.log('响应', res);
      } catch (error) {
        console.log(error);
      }
    },
    async getUserInfo() {
      try {
        const params = {
          applyUserId: this.applyUserId
        };
        const res = await channelUserGet(params);
        if (res) {
          this.formData.name = res.name || '';
          this.formData.mobilePhone = res.mobilePhone || '';
          this.formData.sex = res.sex || '';
          this.formData.userId = res.userId || '';
          this.formData.applyUserId = res.applyUserId || '';
          this.formData.birthday = res.birthday || '';
          this.applyUserId = res.applyUserId || '';
          if (this.formData.birthday) {
            this.defaultDate = new Date(this.formData.birthday);
          }
        }
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },
    onDateConfirm(date) {
      this.showDatePicker = false;
      const res =
        date.getFullYear() +
        '-' +
        complement0(date.getMonth() + 1) +
        '-' +
        complement0(date.getDate());
      this.formData.birthday = res;
    },
    dateFormatter(type, val) {
      switch (type) {
        case 'year':
          return val + '年';
        case 'month':
          return val + '月';
        case 'day':
          return val + '日';
        default:
          return val;
      }
    },
    countDown() {
      this.countDownSecond--;
      if (this.countDownSecond < 0) {
        clearInterval(this.timer);
        this.pinTitle = '获取验证码';
        this.pinDisable = false;
        return;
      }
      this.pinTitle = '获取验证码' + this.countDownSecond + 's';
    },
    sendpinClick: debounce(
      async function() {
        // 验证码不可点击
        if (this.pinDisable) {
          return;
        }
        if (!this.formData.mobilePhone) {
          Toast('联系电话不能为空');
          return;
        }
        if (
          this.formData.mobilePhone.length != 11 ||
          !MobileRegExp.test(this.formData.mobilePhone)
        ) {
          Toast('请输入正确的联系电话');
          return;
        }
        try {
          await paicApplyUserPhonePinGet({ phone: this.formData.mobilePhone });
          this.pinDisable = true;
          Toast('获取验证码成功');
          this.countDownSecond = 60;
          this.timer = setInterval(this.countDown, 1000);
        } catch (error) {
          console.log(error);
        }
      },
      2000,
      { leading: true, trailing: false }
    )
  }
};
</script>

<style lang="scss" scoped>
.apply-add-wrap {
  border-radius: 10px 10px 0 0;
  background: #ffffff;
  font-size: 15px;
  ::v-deep .van-cell--required {
    &:before {
      content: "";
    }
    .van-cell__title.van-field__label {
      color: #333333;
      span {
        position: relative;
        &:before {
          position: absolute;
          right: -8px;
          color: #ee0a24;
          font-size: 14px;
          content: "*";
        }
      }
    }
  }

  ::v-deep .van-field__control::-webkit-input-placeholder {
    color: #cccccc;
    font-size: 14px;
    font-family: PingFangSC-Regular;
  }

  .title-wrap {
    position: relative;
    width: 100vw;
    height:44px;
    border-radius: 10px 10px 0 0;
    font-size: 17px;
    text-align: center;
    color: #222222;
    background: #ffffff;
    line-height: 44px;
    letter-spacing: 0;
    text-align: center;

    .close-img {
      position: absolute;
      width: 24px;
      height: 24px;
      right: 15px;
      top: 10px;
    }
  }

  .cell {
    box-sizing: border-box;
    background: #fff;
    font-size: 30px;
    .img {
      width: 0.35rem;
    }
  }
  .send-pin-cell {
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
    font-size: 15px;
    font-family: PingFangSC-Regular;

    .line {
      width: 1px;
      height: 22px;
      background: #e5e5e5;
    }
    .send-btn {
      font-size: 14px;
      text-align: right;
      padding-right: 0.3rem;
      padding-left: 0.24rem;
      .unsent {
        color: #222222;
      }
      .count-down {
        display: inline-block;
        color: #bcbfcc;
      }
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 60px;
    background: #fff;
    font-weight: 400;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    padding: 0 20px;
    padding-bottom: 5px;
    flex: 1;
    .btn {
      height: 45px;
      border: 0px;
      border-radius: 22.5px;
      color: #ffffff;
      width: 100%;
      margin-left: 20px;
      background-image: linear-gradient(90deg, #ff6b22 0%, #ff8727 100%);
    }
    .btn-cancel {
      height: 45px;
      border: 1px solid #e5e5e5;
      border-radius: 22.5px;
      color: #a5a5a5;
      width: 100%;
      background: #ffffff;
    }
  }

  .info-item {
    display: flex;
    align-items: center;
    font-size: 15px;

    .label-wrap {
      width: 1.62rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      align-content: center;
      text-align: center;
      .label {
        text-align: left;
        color: #333333;
        position: relative;
        font-family: PingFangSC-Regular;
      }
      .sex-tips {
        color: #ee0a24;
        font-size: 14px;
      }
    }

    .sex-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin-left: 12px;
    }
  }

  .tips {
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #ff6300;
    text-align: center;
    font-weight: 400;
    text-align: center;
    padding: 16px 12px;
    line-height: 21px;
    background: white;
  }

  .custom-field-font {
    font-size: 15px;
    font-family: PingFangSC-Regular;
    color: #333333;
  }
}
</style>
